import request from '../requesters/default'
import type { LbgSharedOwnershipTypeRefDataResp } from '../service/mortgage-application'

export const fetchLBGSharedOwnershipCompanyList = async () => {
  const response = await request.get<LbgSharedOwnershipTypeRefDataResp>(
    '/mortgage-application/lbg/ref_data/shared_ownership_type',
  )

  return response.data.shared_ownership_type_ref_data
}

export const checkAuthLbg = async (body: LbgAuthCreds) => {
  const response = await request.post('/mortgage-application/check_auth', body)
  return response?.data
}
